import { useMutation, useQueryClient } from '@tanstack/react-query';
import { apiClient } from '@copro/api';
import { enqueueSnackbar } from '../../../components/GlobalSnackbar/snackbarStore';
import { keys } from './keys';

type Variables = {
  id: string;
  name: string;
};

async function updateDocumentType(variables: Variables) {
  const { data, error } = await apiClient
    .from('document_types')
    .update({
      name: variables.name.trim(),
    })
    .eq('id', variables.id)
    .select()
    .single();

  if (error) {
    if (error.code === '23505') {
      throw new Error('Un type de document avec ce nom existe déjà.');
    }
    throw error;
  }

  return data;
}

export function useUpdateDocumentType() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (variables: Variables) => updateDocumentType(variables),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: keys.documents });
      enqueueSnackbar('Type de document modifié avec succès.', 'success');
    },
    onError: (error: Error) => {
      enqueueSnackbar(error.message || 'Erreur lors de la modification du type de document.', 'error');
    },
  });
}
